import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuthContext } from '@/modules/auth/ui/AuthProvider';
import { useAdminApp } from '@/modules/admin/context/AdminAppContext';
import AdminPrivateNotesSection from '@/modules/admin/components/AdminPrivateNotesSection';
import AdminNotesSection from '@/modules/admin/components/AdminNotesSection';

export default function AdminAppNotesPage() {
  const { appId } = useParams();
  const { authFetch } = useAuthContext();
  const { app, adminNotes, loadApp, handleAddNote, addingNote, showToast } = useAdminApp();

  return (
    <div className="mt-6">
      {/* Private Admin Notes Section */}
      <AdminPrivateNotesSection
        appId={appId}
        adminNotes={adminNotes || []}
        onRefresh={() => loadApp(appId)}
        authFetch={authFetch}
        showToast={showToast}
      />

      {/* Public Notes Section (Customer Messages) */}
      <AdminNotesSection
        app={app}
        appId={appId}
        onAddNote={(content) => handleAddNote(appId, content)}
        addingNote={addingNote}
      />
    </div>
  );
}
